import {useEffect, useState} from 'react'
import * as component from '../../../components/redux/componentRedux'
import {useDispatch} from 'react-redux'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Button} from '@mui/material'
import {IDataPage} from '../SignatureFilePage'
import {signProductFileFast} from '../apis'
type Props = {
  dataPage: IDataPage
}
const SignatureFile = ({dataPage}: Props) => {
  const [srcFrame, setSrcFrame] = useState('')
  const [status, setStatus] = useState({
    loading: true,
    error: false,
  })
  const dispatch = useDispatch()

  useEffect(() => {
    signProductFileFast(dataPage)
    .then((res: any) => {
      if (res && !res.isError) {
        setStatus({
          loading: false,
          error: false,
        })
        dispatch(component.actions.showBackdrop({show: false}))
      }
    })
    .catch(() => {
      setStatus({
        loading: false,
        error: true,
      })
      dispatch(component.actions.showBackdrop({show: false}))
    })
  },[])

  return (
    <div>

              <div className='d-flex flex-column flex-root'>
                <div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'>
                  <div className='d-flex flex-column flex-column-fluid text-center p-10 py-lg-10'>
                    <div className='pt-lg-10 mb-10'>
                      <img src={toAbsoluteUrl('/media/illustrations/paid.png')} alt='' />
                      <h1
                        className='fw-bolder fs-3x text-gray-700'
                        style={{margin: '25px 0', color: '#1f8ce9'}}
                      >
                        Ký số thành công/ Digitally signed successfully
                      </h1>
                    </div>
                  </div>
                </div>
              </div>
       
    </div>
  )
}

export default SignatureFile
